import { useNavigate } from "react-router-dom";
import { Input, Table, Button } from 'antd'

import useAccounts from '../../hooks/accounts/useAccounts';

const { Search } = Input;

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',

  },
  {
    title: 'Email',
    dataIndex: 'email',
  },
];

function Accounts() {
  const accountsQuery = useAccounts();
  const navigate = useNavigate();

  return (
    <>
      <h1>Accounts</h1>
      <Button type="primary" onClick={() => navigate('/accounts/new')} >New</Button>
      <div style={{ padding: 24, background: '#f0f2f5', marginTop: 12}}>
        <Search
          placeholder='Pesquisar'
        />
        <Table 
          style={{ marginTop: 24, minHeight: 500}} 
          columns={columns}
          rowKey={record => record.id}
          dataSource={accountsQuery.data}
          loading={accountsQuery.isLoading}
          onRow={(record) => {
            return {
              onClick: () => { navigate(`/accounts/${record.id}`);},
            }}}
        />
      </div>
    </>
  );
}

export default Accounts